import React, { useContext, Fragment } from 'react';

import { styled } from '@mui/material/styles';
import { Typography, Divider, Button, Box } from '@mui/material';

import { AppContext } from 'AppContext';

const PREFIX = 'Tariff';

const classes = {
  root: `${PREFIX}-root`,
  info: `${PREFIX}-info`,
  infoActive: `${PREFIX}-infoActive`,
  name: `${PREFIX}-name`,
  description: `${PREFIX}-description`,
  price: `${PREFIX}-price`,
  divider: `${PREFIX}-divider`,
  feature: `${PREFIX}-feature`,
  featureList: `${PREFIX}-featureList`,
  buttonWrap: `${PREFIX}-buttonWrap`,
};

const Root = styled('div')(({ theme }) => ({
  [`&.${classes.root}`]: {
    flex: '1 1 0',
    display: 'flex',
    flexDirection: 'column',
  },

  [`& .${classes.info}`]: {
    flex: 1,
    padding: '20px 20px 24px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    borderRadius: 4,
    border: '2px solid #213955',
    boxShadow: '0px 0px 0px rgba(63, 63, 68, 0.05), 0px 1px 3px rgba(63, 63, 68, 0.15)',
  },

  [`& .${classes.infoActive}`]: {
    flex: 1,
    padding: '20px 20px 24px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    borderRadius: 4,
    border: '2px solid rgba(232, 60, 83, 0.7)',
    backgroundColor: 'rgba(232, 60, 83, 0.04)',
    boxShadow: '0px 0px 0px rgba(63, 63, 68, 0.05), 0px 1px 3px rgba(63, 63, 68, 0.15)',
  },

  [`& .${classes.name}`]: {
    textTransform: 'uppercase',
    color: '#607D8B',
    fontSize: 11,
    marginTop: 20,
    fontWeight: 500,
  },

  [`& .${classes.description}`]: {
    textTransform: 'uppercase',
    color: '#607D8B',
    fontSize: 11,
    marginTop: 15,
    fontWeight: 500,
    textAlign: 'center',
  },

  [`& .${classes.price}`]: {
    marginTop: 15,
    fontSize: 20,
    color: '#263238',
    fontWeight: 500,
    textAlign: 'center',
  },

  [`& .${classes.divider}`]: {
    marginTop: 15,
    width: '80%',
  },

  [`& .${classes.feature}`]: {
    fontSize: 10,
    textAlign: 'center',
    lineHeight: '15px',
    marginTop: 10,
  },

  [`& .${classes.featureList}`]: {
    listStyleType: 'none',
    padding: 0,
    margin: 0,
  },

  [`& .${classes.buttonWrap}`]: {
    marginTop: 'auto',
    paddingTop: 24,
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  },
}));

const Tariff = ({ data, active }) => {
  const appContext = useContext(AppContext);

  const { icon, price, description, features, name, id } = data;

  const renderButton = () => {
    if (id === 'basic') {
      if (active) return null;
      return (
        <Button
          variant='outlined'
          fullWidth
          onClick={() => appContext.history.push('/profile/account/change-tariff/basic')}
        >
          Перейти
        </Button>
      );
    }

    if (id === 'ultimate') {
      if (active) {
        return (
          <Button
            variant='contained'
            color='primary'
            fullWidth
            onClick={() => appContext.history.push('/profile/account/change-tariff/standart')}
          >
            Оплатить
          </Button>
        );
      }
      return (
        <Button
          variant='contained'
          color='primary'
          fullWidth
          onClick={() => appContext.history.push('/profile/account/change-tariff/standart')}
        >
          Подключить
        </Button>
      );
    }

    if (id === 'unlimited') {
      return (
        <Button
          variant='outlined'
          fullWidth
          disabled={active}
          onClick={() => appContext.history.push('/profile/account/change-tariff/ultimate')}
        >
          Запросить
        </Button>
      );
    }

    return null;
  };

  const btn = renderButton();

  return (
    <Root className={classes.root}>
      <div className={active ? classes.infoActive : classes.info}>
        {icon}
        <Typography className={classes.name}>{name}</Typography>
        <Typography className={classes.price}>{price}</Typography>
        <Typography className={classes.description}>
          {description.map((r, i) => (
            <Fragment key={i}>
              {r}
              {i < description.length - 1 && <br />}
            </Fragment>
          ))}
        </Typography>
        <Divider className={classes.divider} />
        <ul className={classes.featureList}>
          {features.map((f, i) => (
            <li key={i}>
              <Typography className={classes.feature}>
                {f}
              </Typography>
            </li>
          ))}
        </ul>
        <div className={classes.buttonWrap}>
          {btn || <Box sx={{ height: 36.5 }} />}
        </div>
      </div>
    </Root>
  );
};

export default Tariff;
